
import type { ReactNode } from "react";
import { blurPopUp } from "./animation";
import { motion } from "framer-motion";

type BlurPopUpProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};

type BlurPopUpByWordProps = {
  text: string;
};

export const BlurPopUp = ({ children, delay = 1, className }:BlurPopUpProps) => {
  return (
    <motion.div
      variants={blurPopUp}
      initial="initial"
      whileInView="animate"
      className={className}
      viewport={{ once: true }}
      transition={{ duration: 0.7, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
};

export const BlurPopUpByWord = ({ text }:BlurPopUpByWordProps) => {
  const words = text.split(" ");
  return (
    <span className="block text-balance">
      <span className="inline-block align-top text-balance">
        {words.map((word, idx) => (
          <motion.span
            style={{ wordBreak: "normal" }}
            key={idx}
            variants={blurPopUp}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 * idx }}
          >
            {word + (idx + 1 < words.length ? "    " : "")}
          </motion.span>
        ))}
      </span>
    </span>
  );
};